/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import { ControlState } from "../models/flexible/control-state";
import { GeneralFieldController } from "./general-field-controller";

export class NumberOfPrescriptionsToDateFieldController extends GeneralFieldController {
	override useControlState(): ControlState {
		const [responseReceived] = useFieldValue(AttributeIdentifiers.ResponseReceived);
		return responseReceived ? "enabled" : "disabled";
	}
}
